<template>
  <div
    class="modal fade"
    id="manufacturerInfoWModal"
    tabindex="-1"
    aria-labelledby="manufacturerInfoWModallLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex" >
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              {{ isDentalLaboratory ? '기공소' : '제조사' }} 등록하기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">

          <div class="modalDivWrap">
            <div class="modalPartTitle">{{ isDentalLaboratory ? '기공소' : '제조사' }} 정보 등록</div>
            <div class="modalInputDiv">
              <label for="">사업자등록번호<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="사업자등록 번호를 입력해주세요(ex. 123-45-67890)"
                v-model="businessNumber"
                maxlength="12"
                @input="changeBusinessNumber"
                @keyup.enter="businessNumberValidate"
              />
              <div class="modalInputRight">
                <button
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="businessNumberValidate()"
                >
                  중복확인
                </button>
              </div>
            </div>
            <div class="modalInputDiv" style="padding: 0!important">
              <label for=""/>
              <span class="businessNumberMsgW fail"></span>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for=""/>
              <button 
                class="btn btn-primary"
                @click="openBusinessFileInput()"
                style="margin-bottom: 0!important;"
              >등록증 업로드</button>
              <span 
              class="imgspan hoverPointer"  
              style="margin-left: 10px; width: 40%; overflow: hidden; "
              @click="downloadBusinessNumImage()"
              >{{ businessFileName }}</span>
              <input
              type="file"
              id="businessFileInputW"
              ref="businessFileInputW"
              @change="changeBusinessNumImage()"
              />
            </div>
            <div class="modalInputDiv">
              <label>테스트 {{ isDentalLaboratory ? '기공소' : '제조사' }} 여부</label>
              <div class="radioWrap">
                <div class="radioObj">
                  <a-checkbox
                    v-model:checked="isTestCompany"
                    id="isTestCompanyW"
                  />
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label for="">국가 선택<span class="requiredSpan">*</span></label>
              <select
                v-model="selectedLocale"
                @change="onLocaleChange"
                style="
                  width: 30%;
                  border-radius: 5px;
                  border-width: 1px;
                  height: 35px;"
              >
                <option
                  v-for="option in countryOptions"
                  :value="option.value"
                  :key="option.value"
                >{{ option.label }}</option>
              </select>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">진료 과목<span class="requiredSpan">*</span></label>
              <div class="radioWrap">
                <div class="radioObj" v-for="(item, i) in deptList" :key="i">
                  <input 
                  type="checkbox" 
                  :value="item.code"
                  :id="item.code+'W'"
                  v-model="medicalDept"
                  /> 
                  <label :for="item.code+'W'">{{ item.name }}</label>
                </div>
              </div>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">{{ isDentalLaboratory ? '기공소명' : '제조사명' }}<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="사업자등록증에 등록된 업체명을 입력하세요."
                v-model="manufacturerName"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">지역 구분<span class="requiredSpan">*</span></label>
              <select v-model="selectedAreaFirst" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                height: 35px;" id="itemCode"
                @change="areaSecondChange()"
              >
                <option value="" selected>시/도 선택</option>
                <option v-for="item in areaFirst" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
              <select v-model="selectedAreaSecond" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                margin-left: 20px;
                height: 35px;" id="itemCode"
                @change="areaThirdChange()"
              >
                <option value="" selected>시/군/구 선택</option>
                <option v-for="item in areaSecond" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
              <select v-model="selectedAreaThird" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                margin-left: 20px;
                height: 35px;" id="itemCode"
              >
                <option value="" selected>읍/면/동 선택</option>
                <option v-for="item in areaThird" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
            </div>
            <div class="modalInputDiv">
              <label for="">상세 주소</label>
              <input
                type="text"
                placeholder="나머지 상세주소를 입력하세요."
                v-model="addrDetail"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">대표 전화번호<span class="requiredSpan">*</span></label>
              <input
              type="text"
              :placeholder="phonePlaceholder"
              v-model="manufacturerPhoneNumber"
              maxlength="20"
              @input="changeManufacturerPhoneNumber"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">페이지 로고<span class="requiredSpan">*</span></label>
              <button 
                class="btn btn-primary"
                @click="openLogoFileInput()"
                style="margin-bottom: 0!important;"
              >이미지 업로드</button>
              <input
              type="file"
              id="logoFileInputW"
              accept="image/jpeg, image/png"
              ref="logoFileInputW"
              @change="changeLogoImage()"
              />
            </div>
            <div class="modalInputDiv">
              <label for=""/>
              <div>
                <span class="imgspan"
                > 
                <img src="#" alt="" id="logoPrevW" class="hoverPointer" @click="downloadLogoImage()" />
                </span>
                <div>
                  <span 
                  class="imgspan hoverPointer"
                  @click="downloadLogoImage()"
                  >{{logoFileName}}</span>
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label for=""/>
              <div class="modalTextSmall">
                이미지 권장 사이즈는 300*60입니다. 파일 크기는 최대 100MB까지 등록 가능합니다.
              </div>
            </div>
            <section
              v-if="!isDentalLaboratory"
              data-testid="manufacturer-favicon"
              class="modalDivWrap"
              aria-labelledby="manufacturerFaviconTitleW"
            >
              <div id="manufacturerFaviconTitleW" class="modalPartTitle">
                브라우저 favicon
              </div>
              <div class="modalInputDiv">
                <label for="manufacturerFaviconInputW">favicon 이미지</label>
                <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="faviconUploading || companyCreated"
                  @click="openFaviconFileInput"
                >
                  PNG 선택
                </button>
                <input
                  id="manufacturerFaviconInputW"
                  ref="faviconFileInputW"
                  type="file"
                  accept="image/png"
                  :disabled="faviconUploading || companyCreated"
                  @change="changeFaviconImage"
                />
              </div>
              <div v-if="faviconPreviewUrl" class="modalInputDiv">
                <label>미리보기</label>
                <img
                  :src="faviconPreviewUrl"
                  width="48"
                  height="48"
                  alt="선택한 제조사 favicon 미리보기"
                  style="object-fit: contain"
                />
                <span class="modalTextSmall" style="margin-left: 10px">
                  {{ faviconFile && faviconFile.name }}
                </span>
              </div>
              <div class="modalInputDiv">
                <label />
                <div class="modalTextSmall">
                  PNG · 정사각형 · 16~512px · 최대 1MiB. 제조사 등록이 완료된
                  뒤 자동으로 업로드합니다.
                </div>
              </div>
              <div class="modalInputDiv">
                <label />
                <div aria-live="polite" role="status">
                  <span :class="faviconStatus === 'error' ? 'fail' : 'success'">
                    {{ faviconStatusMessage }}
                  </span>
                  <button
                    v-if="faviconStatus === 'error' && createdCompanyId"
                    type="button"
                    class="btn btn-primary"
                    :disabled="faviconUploading"
                    style="margin-left: 10px"
                    @click="retryFaviconUpload"
                  >
                    {{ faviconUploading ? "업로드 중..." : "다시 업로드" }}
                  </button>
                </div>
              </div>
            </section>
            
          </div>
          <div class="modalDivWrap">
            <div class="modalPartTitle">관리자 정보 등록</div>
            <div class="modalInputDiv">
              <label for="">관리자 이름<span class="requiredSpan">*</span></label>
              <input
                type="text"
                :placeholder="`해당 ${isDentalLaboratory ? '기공소' : '제조사'}의 관리자 이름을 입력해주세요.`"
                v-model="managerName"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">관리자 직급</label>
              <input
                type="text"
                placeholder="관리자의 직급을 입력해주세요."
                v-model="managerDuty"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">관리자 연락처<span class="requiredSpan">*</span></label>
              <input
                type="text"
                :placeholder="managerPhonePlaceholder"
                v-model="managerPhoneNumber"
                maxlength="20"
                @input="changeManagerPhoneNumber"
              />
              <div class="modalInputRight"/>
            </div>
            <input
            type="text"
            style="width:0px !important; height: 0px !important; display: none;"
          />
            <input
            type="password"
            style="width:0px !important; height: 0px !important; display: none;"
            />
            <div class="modalInputDiv">
              <label for="">관리자 이메일<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="관리자의 이메일 주소를 입력해주세요."
                v-model="managerId"
                @keyup.enter="managerIdValidate"
                @input="changeManagerId"
              />
              <div class="modalInputRight">
                <button
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="managerIdValidate()"
                >
                  중복확인
                </button>
              </div>
            </div>
            <div class="modalInputDiv" style="padding: 0!important">
              <label for=""/>
              <span class="managerIdMsgW fail"></span>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">관리자 비밀번호<span class="requiredSpan">*</span></label>
              <input
                type="password"
                placeholder="비밀번호를 입력해주세요."
                v-model="password"
                autocomplete=off
                @input="passwordOnChange"
                />
                <div class="modalInputRight"/>
              </div>
              <div class="modalInputDiv">
                <label for="">비밀번호 확인<span class="requiredSpan">*</span></label>
                <input
                type="password"
                placeholder="비밀번호 재입력"
                v-model="passwordConfirm"
                autocomplete=off
                @input="passwordOnChange"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv" style="padding: 0!important">
              <label for=""/>
              <span class="passwordMsg fail"></span>
              <div class="modalInputRight"/>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            :disabled="faviconUploading"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-info"
            :disabled="faviconUploading || companyCreated"
            @click="addManufacturer()"
          >
            {{ faviconUploading ? "favicon 업로드 중..." : "등록하기" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  YnEnum
} from '@/enums/common.enums';
import jsonFile from "../../assets/locations.json";
import { businessNumberFormatter, changeBytesToKilos, openDialog, phoneNumberFormatterByLocale, } from "../../utils/utils";
import { getCountryOptions, getCountryConfig, DEFAULT_LOCALE } from "@/constants/countryPhone";
import {
  getManufacturerFaviconUrl,
  uploadManufacturerFavicon,
  validateManufacturerFaviconFile,
} from "@/views/ManufacturerManagement/api";
import {
  finalizePreviewBeforeReload,
  retryManufacturerFaviconMutation,
  runManufacturerFaviconCreation,
} from "@/views/ManufacturerManagement/favicon-workflow.mjs";

export default {
  props: {
    isDentalLaboratory: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      // type은 computed에서 동적으로 결정

      deptList: [], // 제조사 구분
      manufacturerName: "", // 업체명
      manufacturerPhoneNumber: "", // 대표 전화번호
      businessNumber: "", // 사업자등록번호
      areaFirst: [], // 시군구 대분류
      areaSecond: [], // 시군구 중분류
      areaThird: [], // 읍면동 소분류
      selectedAreaFirst: "", // 선택된 시군구 대분류
      selectedAreaSecond: "", // 선택된 시군구 중분류
      selectedAreaThird: "", // 선택된 읍면동 소분류
      addrDetail: "", // 상세주소
      medicalDept: [], // 선택된 제조사구분

      managerName: "", // 관리자 이름
      managerDuty: "", // 관리자 직급
      managerPhoneNumber: "", // 관리자 연락처
      managerId: "", // 관리자 아이디
      password: "", // 관리자 비밀번호
      passwordConfirm: "", // 비밀번호 확인

      businessFileName: "", // 사업자이미지 파일명
      businessFileData: null, // 실제 사업자이미지파일 정보가 담긴 폼데이터
      businessImgUrl: "", // objectStorage 상 사업자이미지 url

      logoFileName: "", // 로고이미지 파일명
      logoFileData: null, // 실제 로고파일 정보가 담긴 폼데이터
      logoImgUrl: "", // objectStorage 상 로고이미지 url

      faviconFile: null,
      faviconPreviewUrl: "",
      faviconStatus: "idle",
      faviconError: "",
      faviconUploading: false,
      companyCreated: false,
      createdCompanyId: "",

      isBusinessNumberValid: false, // 사업자등록증 검증 여부
      isPasswordValid: false, // 비밀번호 유효성 검증 여부
      isManagerIdValid: false, // 관리자 아이디 유효성 검증 여부
      isTestCompany: false, // 테스트 제조사 여부

      // 국가/지역 설정
      selectedLocale: DEFAULT_LOCALE, // 선택된 국가 코드
      countryOptions: getCountryOptions(), // 국가 선택 옵션 목록
    };
  },
  computed: {
    type() {
      return this.isDentalLaboratory ? "DENTAL_LABORATORY" : "MANUFACTURER";
    },
    faviconStatusMessage() {
      if (this.faviconStatus === "selected") {
        return "제조사 등록 후 업로드할 PNG가 선택되었습니다.";
      }
      if (this.faviconStatus === "uploading") return "favicon을 업로드하고 있습니다.";
      if (this.faviconStatus === "success") return "favicon 업로드가 완료되었습니다.";
      if (this.faviconStatus === "error") return this.faviconError;
      return "favicon은 선택 사항입니다.";
    },
    // 현재 선택된 국가의 전화번호 placeholder
    phonePlaceholder() {
      const config = getCountryConfig(this.selectedLocale);
      return `대표 전화번호를 입력해주세요(ex. ${config.placeholder})`;
    },
    managerPhonePlaceholder() {
      const config = getCountryConfig(this.selectedLocale);
      return `관리자의 연락처를 입력해주세요(ex. ${config.placeholder})`;
    }
  },
  async mounted() {
    this.initValues();
    this.getAreaList();
    await this.getDeptList();
    this.$el.addEventListener("hidden.bs.modal", this.handleFaviconModalClosed);
  },
  beforeUnmount() {
    this.$el.removeEventListener("hidden.bs.modal", this.handleFaviconModalClosed);
    this.releaseFaviconPreview();
  },
  methods: {
    releaseFaviconPreview() {
      if (this.faviconPreviewUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(this.faviconPreviewUrl);
      }
      this.faviconPreviewUrl = "";
    },
    reloadAfterFaviconPreviewCleanup() {
      finalizePreviewBeforeReload({
        previewUrl: this.faviconPreviewUrl,
        revokeObjectUrl: (url) => URL.revokeObjectURL(url),
        setPreviewUrl: (url) => {
          this.faviconPreviewUrl = url;
        },
        reload: () => location.reload(),
      });
    },
    resetFaviconState() {
      this.releaseFaviconPreview();
      this.faviconFile = null;
      this.faviconStatus = "idle";
      this.faviconError = "";
      this.faviconUploading = false;
      this.companyCreated = false;
      this.createdCompanyId = "";
      if (this.$refs.faviconFileInputW) this.$refs.faviconFileInputW.value = "";
    },
    handleFaviconModalClosed() {
      if (this.companyCreated) {
        this.reloadAfterFaviconPreviewCleanup();
        return;
      }
      this.resetFaviconState();
    },
    openFaviconFileInput() {
      if (this.isDentalLaboratory) return;
      this.$refs.faviconFileInputW?.click();
    },
    changeFaviconImage(event) {
      if (this.isDentalLaboratory) return;
      const file = event.target.files?.[0];
      const validationError = validateManufacturerFaviconFile(file);

      this.releaseFaviconPreview();
      this.faviconFile = null;
      this.faviconError = validationError;
      this.faviconStatus = validationError ? "error" : "selected";

      if (validationError) {
        event.target.value = "";
        return;
      }

      this.faviconFile = file;
      this.faviconPreviewUrl = URL.createObjectURL(file);
    },
    async uploadSelectedFavicon(companyId) {
      if (this.isDentalLaboratory) return true;
      if (!this.faviconFile) return true;

      this.faviconUploading = true;
      this.faviconError = "";
      this.faviconStatus = "uploading";
      try {
        const result = await retryManufacturerFaviconMutation({
          intent: "replace",
          manufacturerId: companyId,
          file: this.faviconFile,
          upload: uploadManufacturerFavicon,
        });
        if (!result.faviconApplied) {
          const errorCode = result.errorCode;
          this.faviconStatus = "error";
          this.faviconError =
            `제조사는 저장되었으나 favicon 저장에 실패했습니다${
              errorCode ? ` (${errorCode})` : ""
            }. 수정 화면에서 재시도해 주세요.`;
          return false;
        }

        const uploadedUrl = getManufacturerFaviconUrl(result.payload);
        if (uploadedUrl) {
          this.releaseFaviconPreview();
          this.faviconPreviewUrl = uploadedUrl;
        }
        this.faviconStatus = "success";
        return true;
      } finally {
        this.faviconUploading = false;
      }
    },
    async retryFaviconUpload() {
      if (this.isDentalLaboratory) return;
      if (!this.createdCompanyId || this.faviconUploading) return;

      const uploaded = await this.uploadSelectedFavicon(this.createdCompanyId);
      if (uploaded) {
        await openDialog("제조사와 favicon 등록이 완료되었습니다.", "success", "확인").then(
          () => this.reloadAfterFaviconPreviewCleanup(),
        );
      }
    },
    changeManufacturerPhoneNumber() {
      this.manufacturerPhoneNumber = phoneNumberFormatterByLocale(this.manufacturerPhoneNumber.toString(), this.selectedLocale);
    },
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatterByLocale(this.managerPhoneNumber.toString(), this.selectedLocale);
    },
    // 국가 변경 시 전화번호 재포맷
    onLocaleChange() {
      if (this.manufacturerPhoneNumber) {
        this.manufacturerPhoneNumber = phoneNumberFormatterByLocale(this.manufacturerPhoneNumber.toString(), this.selectedLocale);
      }
      if (this.managerPhoneNumber) {
        this.managerPhoneNumber = phoneNumberFormatterByLocale(this.managerPhoneNumber.toString(), this.selectedLocale);
      }
    },
    // 사업자등록번호 onChange(사업자등록번호가 달라지면 다시 validation 해야 함)
    changeBusinessNumber() {
      this.businessNumber = businessNumberFormatter(this.businessNumber);
      this.isBusinessNumberValid = false;
      if(document.querySelector(".businessNumberMsgW")) document.querySelector(".businessNumberMsgW").innerHTML = "";
    },
    changeManagerId() {
      this.isManagerIdValid = false;
      if(document.querySelector(".managerIdMsgW")) document.querySelector(".managerIdMsgW").innerHTML = "";
    },
    // 주요 API
    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if(response.status === 200 || response.status === 201) {
          this.deptList = response.data;
        }
      } catch(error) {
        console.log(error);
      }
    },
    // 제조사 등록
    async addManufacturer() {
      if(await this.validateData()) {
        try {
          const obj = {};

          const deptArr = new Array();
          this.medicalDept.forEach((ele) => {
            deptArr.push(ele);
          });

          obj.name = this.manufacturerName;
          obj.cNo = this.businessNumber.replace(/-/g, '');
          obj.addrOne = this.selectedAreaFirst;
          obj.addrTwo = this.selectedAreaSecond;
          obj.addrThree = this.selectedAreaThird;
          obj.addrDetail = this.addrDetail || '';
          obj.medicalDept = deptArr;
          // 기공소 관리 페이지에서는 자동으로 기공소로 설정
          if (this.isDentalLaboratory) {
            obj.isDentalLaboratory = true;
          }
          obj.isTestCompany = this.isTestCompany ? YnEnum.Y : YnEnum.N;
          obj.locale = this.selectedLocale; // 국가/지역 코드

          if(this.businessFileData) {
            const businessImgUrl = await this.uploadImageOnObjectStorage(this.businessFileData);
            obj.cNoUrl = businessImgUrl; 
          } 
          if(this.logoFileData) {
            const logoImgUrl = await this.uploadImageOnObjectStorage(this.logoFileData);
            obj.imgUrl = logoImgUrl; 
          } 

          if(this.manufacturerPhoneNumber) {
            obj.call = this.manufacturerPhoneNumber.replace(/-/g, '');
          } else {
            obj.call = '';
          };

          obj.type = this.type;

          const accountInfo = {};
          accountInfo.username = this.managerId;
          accountInfo.password = this.password;
          accountInfo.role = this.type;
          accountInfo.name = this.managerName;
          if(this.managerDuty) accountInfo.duty = this.managerDuty;
          accountInfo.mobile = this.managerPhoneNumber.replace(/-/g, "");
          obj.accountInfo = accountInfo;

          const response = await this.$apiInstance.post(`/companies`, obj);
          if(response.status === 200 || response.status === 201) {
            this.companyCreated = true;
            if (!this.isDentalLaboratory && this.faviconFile) {
              this.faviconUploading = true;
              this.faviconError = "";
              this.faviconStatus = "uploading";
            }

            const creationResult = await runManufacturerFaviconCreation({
              response,
              file: this.faviconFile,
              isDentalLaboratory: this.isDentalLaboratory,
              upload: uploadManufacturerFavicon,
            });
            this.createdCompanyId = creationResult.manufacturerId;
            this.faviconUploading = false;

            if (!creationResult.faviconApplied) {
              if (creationResult.invalidManufacturerId) {
                this.faviconStatus = "error";
                this.faviconError =
                  "제조사는 저장되었으나 유효한 ID를 확인하지 못해 favicon을 저장하지 못했습니다. 수정 화면에서 재시도해 주세요.";
              } else {
                this.faviconStatus = "error";
                this.faviconError =
                  `제조사는 저장되었으나 favicon 저장에 실패했습니다${
                    creationResult.errorCode ? ` (${creationResult.errorCode})` : ""
                  }. 다시 업로드해 주세요.`;
              }
              return;
            }

            if (creationResult.action === "replace") {
              const uploadedUrl = getManufacturerFaviconUrl(creationResult.payload);
              if (uploadedUrl) {
                this.releaseFaviconPreview();
                this.faviconPreviewUrl = uploadedUrl;
              }
              this.faviconStatus = "success";
            }

            await openDialog(`${this.isDentalLaboratory ? '기공소' : '제조사'} 등록이 완료되었습니다.`,"success", "확인")
          .then(() => {
            this.reloadAfterFaviconPreviewCleanup();
          });
          } else {
            await openDialog(`${this.isDentalLaboratory ? '기공소' : '제조사'} 등록에 실패하였습니다.`, "error", "확인");
          }

        } catch (error) {
          console.log(error);
          if(error.response && error.response.status === 400) {
            await openDialog(error.response.data?.message || "이미 존재하는 계정입니다.", "error", "확인");
          } else if (!this.companyCreated) {
            await openDialog(`${this.isDentalLaboratory ? '기공소' : '제조사'} 등록에 실패하였습니다.`, "error", "확인");
          }
        }
      }
    },
 
    // 파일첨부 창이 잘 안떠서 별도로 만든 클릭 메소드
    openBusinessFileInput() {
      this.$refs.businessFileInputW.click();
    },

    openLogoFileInput() {
      this.$refs.logoFileInputW.click();
    },

    // 파일 형식 검증
    validateFile(file) {
      let result = true;
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg'
      ) {
        alert('png, jpeg, jpg 파일만 첨부 가능합니다.');
        result = false;
      } else if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }
      return result;
    },

    validateFileSize(file) {
      let result = true;
      if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }
      return result;
    },

    // 이미지 미리보기 기능 구현
    changeBusinessNumImage() {
      const fileInput = document.getElementById("businessFileInputW");
      if (fileInput.files && fileInput.files[0]) {
        const validateFileSize = this.validateFileSize(fileInput.files[0]);
        if(validateFileSize) {
          this.businessFileName = fileInput.files[0].name;
          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.businessFileData = formData;
        } else {

        }
      } 
    },

    // 사업자등록증 다운로드
    downloadBusinessNumImage() {
      const fileInput = this.$refs.businessFileInputW;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      }
    },

    // 로고 이미지 다운로드
    downloadLogoImage() {
      const fileInput = this.$refs.logoFileInputW;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      }
    },

    // 이미지 오브젝트스토리지에 업로드
    async uploadImageOnObjectStorage(fileData) {
      const response = await this.$apiInstance.post(`/object-storages`, fileData);
      if(response.status === 200 || response.status === 201) {
        return response.data.url;
        // this.profileImgUrl = response.data.url;
        // localStorage.setItem("companyImageUrlCerti",response.data.url);
      } else {
        return "";
      }
    },


    // 사업자등록번호
    async businessNumberValidate() {
      const businessNumberMsg = document.querySelector(".businessNumberMsgW");
      if (this.businessNumber.replaceAll('-','').length < 10) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgW fail");
          businessNumberMsg.innerHTML = "잘못된 사업자등록번호입니다.";
          this.isBusinessNumberValid = false;
      } else {
        const response = await this.$apiInstance.get(`/companies/duplicateCheck/cNo/${this.businessNumber}`);
        if(response && (response.status === 200 || response.status === 201) && !response.data) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgW success");
          businessNumberMsg.innerHTML = "사용할 수 있는 사업자등록번호입니다.";
          this.isBusinessNumberValid = true;
        } else {
          businessNumberMsg.setAttribute("class", "businessNumberMsgW fail");
          businessNumberMsg.innerHTML = "이미 존재하는 사업자등록번호입니다.";
          this.isBusinessNumberValid = false;
        }
      }
    },
    
    async managerIdValidate (){
      const managerIdMsgW = document.querySelector('.managerIdMsgW');
      if(!this.managerId.trim()) {
        managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
        managerIdMsgW.innerHTML = "아이디를 입력해주세요.";
        this.isManagerIdValid = false;
      } else {
        try {
          const response = await this.$apiInstance.get(`/accounts/duplicateCheck/${encodeURIComponent(this.managerId.trim())}`);
          if (
            response &&
            (response.status === 200 || response.status === 201) &&
            !response.data
            ) {
              managerIdMsgW.setAttribute("class", "managerIdMsgW success");
              managerIdMsgW.innerHTML = "사용 가능한 아이디입니다.";
              this.isManagerIdValid = true;
              // 엘스부터 시작.
              } else {
                managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
                managerIdMsgW.innerHTML = "이미 존재하는 아이디입니다.";
                this.isManagerIdValid = false;
            }
        } catch (error) {
          console.log(error);
          // 숫자 10자리(사업자번호 모양) 등 서버가 막은 이유를 그대로 보여준다.
          managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
          managerIdMsgW.textContent = error.response?.data?.message || "아이디 중복확인에 실패했습니다. 다시 시도해 주세요.";
          this.isManagerIdValid = false;
        }
      }
    },

    // 비밀번호
    passwordOnChange() {
      const passwordMsg = document.querySelector(".passwordMsg");
      if(this.password && (this.password !== this.passwordConfirm)) {
        passwordMsg.innerHTML = "비밀번호가 일치하지 않습니다.";
        this.isPasswordValid = false;
      } else {
        passwordMsg.innerHTML = "";
        this.isPasswordValid = true;
      }
    },

    // 페이지 로고 이미지 미리보기 기능 구현
    changeLogoImage() {
      const fileInput = document.getElementById("logoFileInputW");
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if(validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById("logoPrevW").src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.logoFileName = fileInput.files[0].name;
          document.getElementById("logoPrevW").classList.remove("hide");

          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.logoFileData = formData;
        };
      } else {
        document.getElementById("logoPrevW").src = "";
      }
    },

    // 업로드 전 검증
    async validateData() {
      let result = true;

      if (!this.manufacturerName) {
        await openDialog(`${this.isDentalLaboratory ? '기공소' : '제조사'} 이름을 입력해 주세요.`, "error", "확인");
        result = false;
      } else if (this.medicalDept.length === 0) {
        await openDialog("진료 과목을 선택해 주세요.", "error", "확인");
        result = false;
      } else if( !this.selectedAreaFirst ||
        !this.selectedAreaSecond ||
        !this.selectedAreaThird) {
        await openDialog(`${this.isDentalLaboratory ? '기공소' : '제조사'} 지역을 입력해 주세요.`, "error", "확인");
        result = false;
      } else if(!this.manufacturerPhoneNumber) {
        await openDialog(`${this.isDentalLaboratory ? '기공소' : '제조사'} 대표 전화번호를 입력해 주세요.`, "error", "확인");
        result = false;
      } else if(!this.businessNumber) {
        await openDialog("사업자등록번호를 입력해 주세요.", "error", "확인");
        result = false;
      } else if (this.businessNumber.replaceAll('-','').length < 10) {
        await openDialog("사업자등록번호를 올바르게 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.businessFileName ||
        !this.businessFileData) {
        await openDialog("사업자등록증을 업로드해 주세요.", "error", "확인");
        result = false;
      } else if(!this.logoFileName ||
        !this.logoFileData) {
        await openDialog("페이지 로고 이미지를 업로드해 주세요.", "error", "확인");
        result = false;
      } else if(!this.managerName) {
        await openDialog("관리자 이름을 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.managerPhoneNumber) {
        await openDialog("관리자 연락처를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.managerId) {
        await openDialog("관리자 이메일 주소를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.isManagerIdValid) {
        await openDialog("관리자 이메일 중복확인을 해 주세요.", "error", "확인");
        result = false;
      } else if(!this.password) {
        await openDialog("비밀번호를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.passwordConfirm) {
        await openDialog("입력한 비밀번호를 다시 입력해 주세요.", "error", "확인");
        result = false;
      } else if (!this.isPasswordValid) {
        await openDialog("비밀번호가 일치하지 않습니다.", "error", "확인");
        result = false;
      } else if(!this.isBusinessNumberValid) {
        await openDialog("사업자등록번호 중복확인을 해 주세요.", "error", "확인");
        result = false;
      } 
      return result;
    },


    // 기타 manuInfoW용 utils
    
    // 지역 목록 가져오기
    getAreaList() {
      this.areaFirst = Object.keys(jsonFile).sort((a, b) => a.localeCompare(b, 'ko-KR'));
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
    },

    // 시도 변화에 따른 시군구 값 넣기
    areaSecondChange() {
      if(this.selectedAreaFirst) {
        const secondLevelData = jsonFile[this.selectedAreaFirst];
        if(secondLevelData) {
          this.areaSecond = Object.keys(secondLevelData).sort((a, b) => a.localeCompare(b, 'ko-KR'));
          this.selectedAreaSecond = '';
          this.selectedAreaThird = '';
          this.areaThird = [];
        } else {
          this.selectedAreaSecond = '';
          this.selectedAreaThird = '';
          this.areaSecond = [];
          this.areaThird = [];
        }
      } else {
        this.selectedAreaSecond = "";
        this.selectedAreaThird = "";
        this.areaSecond = [];
        this.areaThird = [];
      }
    },

    // 시군구 변화에 따른 읍면동 값 넣기
    areaThirdChange() {
      if (this.selectedAreaSecond) {
        if(!jsonFile[this.selectedAreaFirst]) {
          this.selectedAreaThird = '';
          this.areaThird = [];
          return;
        }
        const thirdLevelData =
          jsonFile[this.selectedAreaFirst][this.selectedAreaSecond];
          if(thirdLevelData) {
            this.areaThird = Object.keys(thirdLevelData).sort((a, b) => a.localeCompare(b, 'ko-KR'));
            this.selectedAreaThird = '';
          } else {
            this.selectedAreaThird = '';
            this.areaThird = [];
          }
      } else {
        this.selectedAreaThird = '';
        this.areaThird = [];
      }
    },

    // 항목 초기화 용도
    initValues() {
      this.manufacturerName = "";
      this.manufacturerPhoneNumber = "";
      this.businessNumber = "";
      this.managerName = "";
      this.managerPhoneNumber = "";
      this.managerId = "";
      this.password = "";
      this.passwordConfirm = "";
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
      this.addrDetail = "";
      this.selectedLocale = DEFAULT_LOCALE; // 국가 초기화

      this.logoImgUrl = "";
      this.businessImgUrl = "";
      this.logoFileData = null;
      this.businessFileData = null;
      this.resetFaviconState();
 
      let bFileInput = document.getElementById("businessFileInputW").value;
      if (!bFileInput.length || bFileInput === "") {
        this.businessFileName = "";
      }
      let lFileInput = document.getElementById("logoFileInputW").value;
      if (!lFileInput.length || lFileInput === "") {
        this.logoFileName = "";
      }
      document.getElementById("logoPrevW").src = "";

      this.isBusinessNumberValid = false;
      this.isPasswordValid = false;
    },

    
  },
};
</script>
